import { render, staticRenderFns } from "./SugestaoDeCompra.vue?vue&type=template&id=cb16eae2&scoped=true"
import script from "./SugestaoDeCompra.vue?vue&type=script&lang=js"
export * from "./SugestaoDeCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb16eae2",
  null
  
)

export default component.exports